<template>
    <div class="product warp">
        <div class="main">
            <div class="table">
                <el-table ref="table" :data="tableData" v-loading="loading" border @sort-change="descOrder" :row-key="getRowKeys" style="width: 100%" @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="55" align="center" v-if="!isAll" :reserve-selection="true"> </el-table-column>
                    <el-table-column prop="spu_id" align="center" label="商品spuid" width="90"> </el-table-column>
                    <el-table-column align="center" prop="image_main" label="商品主图" width="130">
                        <template slot-scope="scope">
                            <el-avatar shape="square" :size="60" fit="cover" :src="scope.row.image_main"></el-avatar>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="name" label="商品名称" show-overflow-tooltip width="130"> </el-table-column>
                    <el-table-column align="center" prop="sta_name" label="商品标准名称" width="130" clearable filterable>
                        <template slot-scope="{ row }">
                            {{ row.sta_name | dataFmt }}
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="brand_name" label="品牌名称" width="130">
                        <template slot-scope="{ row }">
                            {{ row.brand_name | dataFmt }}
                        </template>
                    </el-table-column>

                    <el-table-column align="center" width="130" prop="total_sales_nums" sortable="custom" label="销量"> </el-table-column>
                    <el-table-column align="center" width="130" prop="total_stock" sortable="custom" label="库存"> </el-table-column>
                    <!-- <el-table-column align="center" width="140" prop="goods_spu" sortable="custom" label="商品编号"> </el-table-column> -->
                    <!-- <el-table-column align="center" width="130" prop="goods_brand_id" sortable="custom" label="商品品牌id"> </el-table-column> -->
                    <!-- <el-table-column align="center" width="130" prop="shop_id" sortable="custom" label="商家店铺id"> </el-table-column> -->
                    <el-table-column align="center" width="130" prop="status" sortable="custom" label="上架状态"> 
                        <template slot-scope="{ row }">
                          <span v-if="activeName=='sj'">
上架
                          </span>
                          <span v-else>
                             {{ row.status == 0 ? '下架' : (row.status == 2 ? '强制下架' : '上架') }}
                          </span>
                           
                        </template>
                    </el-table-column>
                    <!-- <el-table-column align="center" width="130" prop="undercarriage_reason" sortable="custom" label="强制下架原因"> </el-table-column> -->
                    <!-- <el-table-column align="center" width="130" prop="sta_name" sortable="custom" label="商品标砖名称"> </el-table-column> -->
                    <el-table-column align="center" width="130" prop="standard_id"  sortable="custom" label="商品标准库id"> </el-table-column>
                    <!-- <el-table-column align="center" width="130" prop="prices_mains" sortable="custom" label="销售价"> </el-table-column> -->
                    <!-- <el-table-column align="center" width="130" prop="prices_defaults" sortable="custom" label="市场价"> </el-table-column> -->
                    <el-table-column align="center" width="130" prop="audit_status" label="审核状态" v-if="isAll">
                        <template slot-scope="scope">
                    <!--         <div v-if="scope.row.status == 2">
                                <el-link type="primary" @click="showCen(1, scope.row)">强制下架</el-link>
                            </div>
                            <div v-else-if="scope.row.status == 3">
                                <span>禁售</span>
                            </div>
                            <div v-else>
                                {{ scope.row.status == 0 ? "下架" : "上架" }}
                            </div>
                            <div v-if="scope.row.status != 3"> -->
                                <div v-if="scope.row.audit_status == 3">
                                    <el-link type="primary" @click="showCen(2, scope.row)">审核拒绝</el-link>
                                </div>
                                <div v-else>
                                    {{ scope.row.audit_status == 1 ? "待审核" : "审核通过" }}
                                </div>
                         <!--    </div> -->
                        </template>
                    </el-table-column>
                    <!-- <el-table-column align="center" width="130" prop="goods_specifications_type_id" label="规格类型">
                        <template slot-scope="{ row }">
                            {{ row.goods_specifications_type_id == 1 ? "单规格" : "多规格" }}
                        </template>
                    </el-table-column>
                    <el-table-column align="center" width="130" label="商品规格" v-if="!isAll">
                        <template slot-scope="scope">
                            <div v-if="scope.row.goods_specifications_type_id == 2">
                                <el-link type="primary" @click="productDetail(scope.row.id)">选择规格</el-link>
                                <p v-if="scope.row.selCount && scope.row.selCount > 0">已选 {{ scope.row.selCount }} 个</p>
                            </div>
                            <span v-else>-</span>
                        </template>
                    </el-table-column> -->
                      <el-table-column align="center" label="预审核状态" width="100">
                        <template slot-scope="scope">
                       {{scope.row.standard_status==0?'失败':'成功'}}
                        </template>
                      </el-table-column>
                      <el-table-column align="center" label="预审核异常原因" width="200" >
                         <template slot-scope="scope">
                          <span v-if="scope.row.standard_reason"  style="color:red">{{scope.row.standard_reason }},请重新编辑</span>
                          <span v-else>-</span>
                        </template>
                      </el-table-column>
                    <el-table-column align="center" label="操作" width="200" fixed="right">
                        <template slot-scope="scope">
                            <span v-if="isAll">
                                <el-link v-if="scope.row.audit_status == 2 && scope.row.status == 0" @click="shelves(scope.row, 1)" type="primary" style="margin-right: 10px">上架</el-link>
                               <el-link v-if="scope.row.status != 1 && scope.row.status != 3 && scope.row.status != 4" @click="update(scope.row)" type="primary" style="margin-right: 10px">编辑</el-link>
                                <el-popconfirm v-if="scope.row.status == 0 && scope.row.status == 2" title="确定删除吗？" @confirm="Delete(scope.row)">
                                    <el-link slot="reference" type="primary" style="margin-right: 10px">删除</el-link>
                                </el-popconfirm>
                            </span>
                            <el-link v-if="scope.row.audit_status == 2 && scope.row.status == 1" @click="shelves(scope.row, 0)" type="primary" style="margin-right: 10px">下架</el-link>
                            <el-link v-if="scope.row.status != 2" type="primary" @click="details(scope.row)">详情</el-link>
                            <el-link type="primary" v-show="!isAll" @click="getWordFunc(scope.row.id)" style="margin-left: 10px">推荐语</el-link>
                          <!--   <el-link type="primary" style="margin-left: 20px"    v-if="scope.row.audit_status == 2 && scope.row.status == 1"  @click="selectActivity"  >添加到活动</el-link> -->
                        </template>
                    </el-table-column>
                </el-table>
                <div class="selectAll" v-if="!isAll">
                    <div>
                        <el-checkbox v-model="selectAll" @change="selectProduct">当前页全选</el-checkbox>
                        <p style="margin-left: 22px">已选 {{ multipleSelection.length + skuData.length }} 个商品</p>
                           <el-button type="primary" style="margin-left: 20px"      @click="selectActivity" :disabled='this.multipleSelection==0' >添加到活动</el-button>
                         <!-- @click="selectActivity" -->
                     <!--    <el-button type="primary" size="small" @click="yearActive" style="margin-left: 60px">参加年货节</el-button><span style="margin-left: 12px">提示：参加年货节更多展现</span> -->
                    </div>
                    <el-button type="danger" size="small" @click="clearData">清空</el-button>
                </div>
                <div class="page">
                    <el-pagination
                        @size-change="sizeChange"
                        @current-change="handleSizeChange"
                        :current-page="page"
                        :page-sizes="[10, 20, 30, 40]"
                        :page-size="size"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                        background
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
        <!-- <el-dialog width="35%" title="订单详情" :visible.sync="dialogFormVisible">
            <datails :ids='formsdatas' :phone="phone" v-if='dialogFormVisible'></datails>
              <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
            </div>
        </el-dialog> -->
        <el-dialog :title="isShow ? '审核失败原因' : '强制下架原因'" :visible.sync="centerDialogVisible" width="476px" center>
            <div class="dia-content" v-loading="isLoad">
                <span>{{ info }}</span>
            </div>
        </el-dialog>
        <el-dialog title="推荐语" :visible.sync="dialogVisible" width="562px" :before-close="handleClose">
            <div v-loading="wordLoad">
                <p style="margin-bottom: 10px">推荐语：</p>
                <el-input type="textarea" :rows="4" placeholder="请输入推荐语" v-model="words"> </el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose" size="small">取 消</el-button>
                <el-button type="primary" @click="wordSubmit" :loading="btnLoad" size="small">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
// import datails from './components/details.vue'
export default {
    name: "product",
    data() {
        return {
            // 推荐语
            dialogVisible: false,
            wordLoad: false,
            words: "",
            goods_mains_id: "",
            btnLoad: false,
            wordType: "",
            // 推荐语
            tableData: [],
            dialogFormVisible: false,
            centerDialogVisible: false,
            loading: false,
            total: 0,
            size: 10,
            page: 1,
            formsdatas: 0,
            ordersNumber: "",
            phone: "",
            orderby: null,
            info: "暂无内容！",
            isShow: false,
            isLoad: false,
            multipleSelection: [],
            selectAll: false,
        };
    },
    filters: {
        dataFmt(val) {
            if (typeof val == "string") return val.replace(/\,/g, " / ");
            return val;
        },
    },
    props: {
        isAll: {
            type: Boolean,
        },
        productId: {
            type: String,
        },
        titles: {
            type: String, //商品名称搜索
        },
        leix: {
            type: String,
        },
        activeName: {
            type: String,
        },
        customer: {
            type: Array,
        },
        status: {
            type: Number,
        },
        merchandise_inventory: {
            type: Array,
            default: () => {
                return [];
            },
        },
        prices_mains: {
            type: Array,
            default: () => {
                return [];
            },
        },
        skuData: {
            type: Array,
            default: () => {
                return [];
            },
        },
        standard_id: {
            type: String,  //商品标准基库id
        }
    },
    components: {
        // datails
    },
    mounted() {},
    created() {
        this.Bind(0);
    },
    methods: {
        ...mapActions({
            getGoodsList: "commodity/newGoodsList",
            proUpdate: "commodity/newUpdateStatus",
            viewAuditsreason: "commodity/viewAuditsreason",
            getWords: "detect/getWords",
            addWords: "detect/addWords",
            editWords: "detect/editWords",
        }),
       
        yearActive() {
            this.$emit("yearActive");
        },
          selectActivity() {
           /*  this.$refs.refSelActivity.dialogVisible = true; */
              this.$emit("selectActivity",this.multipleSelection );
              console.log(5,this.multipleSelection)
        },
        // 推荐语
        getWordFunc(id) {
            this.goods_mains_id = id;
            this.dialogVisible = true;
            this.wordLoad = true;
            this.getWords({ goods_mains_id: id }).then(({ data }) => {
                this.wordLoad = false;
                if (data.code == 200) {
                    if (data.data.length > 0) {
                        this.wordType = "edit";
                        this.words = data.data[0].words || "";
                    } else {
                        this.wordType = "add";
                    }
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        wordSubmit() {
            if (this.words == "") return this.$message.warning("请填写推荐语");
            this.btnLoad = true;
            let url;
            if (this.wordType == "add") {
                url = this.addWords;
            } else {
                url = this.editWords;
            }
            url({ goods_mains_id: this.goods_mains_id, words: this.words }).then(({ data }) => {
                this.btnLoad = false;
                if (data.code == 200) {
                    this.$message.success(`${this.wordType == "add" ? "添加" : "编辑"}成功！`);
                    this.handleClose();
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        handleClose() {
            this.dialogVisible = false;
            this.words = "";
        },
        // 推荐语
        clearData() {
            this.$emit("init");
        },
        updateTree() {
            this.Bind();
        },
        getRowKeys(row) {
            return row.id;
        },
        productDetail(id) {
            this.$emit("productDetail", id);
        },
        selectProduct() {
            this.$refs.table.toggleAllSelection();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            if (this.multipleSelection.length != this.tableData.length * this.page) {
                this.selectAll = false;
            } else {
                this.selectAll = true;
            }
            this.$emit("selectSpu", this.multipleSelection);
        },
        viewAuditsreasonFn(id) {
            this.isLoad = true;
            this.isShow = true;
            let opt = {
                token: this.$store.state.token,
                id: id,
            };
            this.viewAuditsreason(opt).then((res) => {
                this.isLoad = false;
                if (res.code == 1) {
                    this.info = res.data.audit_refuse_reason;
                }
            });
        },
        showCen(tag, val) {
            this.centerDialogVisible = true;
            if (tag == 1) {
                this.info = val.undercarriage_reason ? val.undercarriage_reason : "暂无内容！";
            } else {
                this.viewAuditsreasonFn(val.id);
            }
        },
        sizeChange(val) {
            this.size = val;
            this.Bind();
        },
        shelves(row, val) {
            const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.proUpdate({
                token: this.$store.state.token,
                id: row.spu_id, //商品id
                status: val,
            }).then((res) => {
                loading.close();
                if (res.code == 1) {
                    this.$message.success("操作成功！");
                    this.Bind();
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        update(row) {
            this.$emit("Operation", { type: 2, id: row.spu_id });
        },
        Delete(row) {
            this.$emit("Operation", { type: 3, id: row.spu_id });
        },
        details(row) {
            let val = {
                type: 1,
                id: row.spu_id,
            };
            this.$emit("Operation", val);
        },
        descOrder(column) {
            if (column.order != null) {
                // let gm = {};
                // local_good.sku_price_sell__desc
                let str = column.order.substring(0, 3) == "asc" ? "desc" : "asc";
                // this.$set(gm, "local_good." + column.prop, str);
                // this.orderby = { ...gm };
                this.orderby = "local_good." + column.prop + '__' + str
            } else {
                this.orderby = null;
            }
            //         column.prop +
            //         " " +
            //         (column.order.substring(0, 3) == "des"
            //             ? column.order.substring(0, 4)
            //             : column.order.substring(0, 3));
            // else this.orderby = "";
            this.Bind(0);
        },
        Bind(tag) {
            if (tag == 0) this.page = 1;
            this.loading = true;
            let data = {
                token: this.$store.state.token, //商家验证token
                page: this.page,
                size: this.size,
                start_total_stock: this.merchandise_inventory[0],   // 最小库存
                end_total_stock: this.merchandise_inventory[1],     // 最大库存
                start_price_sell: this.prices_mains[0],             // 最小销售价
                end_price_sell: this.prices_mains[1],               // 最大销售价
                // merchandise_inventory: this.merchandise_inventory,  // 库存[最小,最大]
                // prices_mains: this.prices_mains,    // 销售价[最小,最大]
            };
            // if (!this.isAll) data.status = 1;
            //审核状态  1 待审核  2 审核通过 3 审核决绝
            if (this.isAll) {
                this.$nextTick(() => {
                    data.audit_status = this.status != 0 ? this.status : null;
                });
            }
            if (this.activeName=='sj') {
              data.status = 1
            }
            if (!this.isAll) {
                data.audit_status = 2;
            }
            // if (this.titles != "") data.tits = this.titles;
            if (this.titles != "") data.name = this.titles;         // 商品名称
            if (this.productId != "") data.id = Number(this.productId); //根据商品id搜索
            if (this.orderby != "") data.orderbys = this.orderby; //排序
            // if (this.leix != "" && this.leix != 0) {
            //     data.classifys_type_id = this.leix;
            // }
            // if (this.customer.length > 0) {
            //     data.standard_id = this.customer;
            // }
            if(this.standard_id != '') data.standard_id = Number(this.standard_id) //商品标准基库id
            this.getGoodsList(data).then(async (res) => {
                if (res.code == 1) {
                    this.tableData.splice(0, this.tableData.length);
                    this.tableData = res.data.list;
                    this.total = parseInt(res.data.count);
                    this.tableData.forEach((item) => {
                        let arr = this.skuData.filter((val) => {
                            return val.spuId == item.id;
                        });
                        item.selCount = arr.length;
                    });
                } else {
                    this.$message.error(res.msg);
                }
                this.loading = false;
            });
        },
        handleSizeChange(val) {
            this.page = val;
            this.Bind();
        },
        handleClick(row) {
            this.formsdatas = parseInt(row.id);
            this.phone = row.phone;
            this.dialogFormVisible = true;
        },
        Refush() {
            this.ordersNumber = "";
            this.Bind(0);
        },
        formok() {
            this.dialogFormVisible = false;
        },
    },
};
</script>
<style lang='scss' scoped>
::v-deep .el-date-editor .el-range-separator {
    padding: 0;
}

.product {
    .main {
        .table {
            margin-top: 20px;
            .el-table {
                min-height: 450px;
            }
            .page {
                margin-top: 20px;
                float: right;
            }
        }
    }
    .dia-content {
        min-height: 100px;
    }
}

.selectAll {
    padding: 20px;
    background: #f4f4f5;
    color: #666;
    margin-top: 20px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    & > div {
        display: flex;
        align-items: center;
    }
    ::v-deep .el-checkbox__label {
        color: #666;
    }
}
</style>
